﻿import { search } from "./overview-filters";
import {
	deleteSearchParam, getSearchParams,
	setSearchParam,
	toggleFilters,
} from "./overview-filter-state";
import {attributes} from "./overview-filter-constants";

const findToggles = (filter) => document.querySelectorAll(`[${attributes.filterToggle}][${attributes.filterName}=${filter}]`);

export const clearToggleInputs = () => {
	for (const filter in toggleFilters) {
		const toggles = findToggles(toggleFilters[filter])
		toggles.forEach(toggle => {
			toggle.checked = false
		});
	}
}

export const anyTogglesOn = () => {
	for (const filter in toggleFilters) {
		const toggles = Array.from(findToggles(toggleFilters[filter]));
		if(toggles.filter(toggle => toggle.checked).length > 0)
			return true;
	}

	return false;
}

export const bindToggles = (filter) => {
	const toggle = findToggles(filter);

	toggle.forEach(toggle => {
		toggle.addEventListener("change", async () => {
			if (toggle.checked)
				setSearchParam(toggleFilters.permanentContract, "true");
			else
				deleteSearchParam(toggleFilters.permanentContract);

			await search();
		});
	});
}

export const setTogglesFromParams = () => {
	const params = getSearchParams();
	for (const filter in toggleFilters) {
		const options = findToggles(toggleFilters[filter]);
		options.forEach(x => {
			x.checked = params.has(toggleFilters[filter]);
		});
	}
}
